import { CookieConsentVersion } from 'constants/consent';
import { stateName } from './constants';
const initialState = {
  cookieConsentVersion: CookieConsentVersion.None
};

const consentReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return state;
};

export const plug = {
  [stateName]: consentReducer
};
export default consentReducer;